import styled from '@emotion/styled';
import { TableCell } from '@mui/material';

export const StyledCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'canClick',
})<{ canClick?: boolean }>(({ canClick }) => ({
  borderRight: '1px solid lightGray',
  paddingTop: '12px',
  paddingBottom: '12px',
  transition: 'background-color 0.2s ease',
  cursor: canClick ? 'pointer' : 'default',
  textDecoration: 'none',
  pointerEvents: canClick ? 'auto' : 'none',

  '&:hover': {
    backgroundColor: canClick ? '#f0f8ff' : 'inherit',
  },
}));
